import Vue from "vue"
import Router from "vue-router"
//import {getCookie, isCompositeCourse} from '@/utils'
import {getCookie} from '@/utils'
import {Message} from "element-ui"

Vue.use(Router)

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
}

export const fixedRoutes = [
  {
    //进入页
    path: "/:flag/entry",
    name: "Entry",
    component: () => import("@/views/Entry/index2024")
  },
  {
    //练习首页
    path: "/:flag/mockExam",
    name: "MockExam",
    component: () => import("@/views/MockExam/index2024"),
    redirect: "/:flag/mockExam/examSystem",
    children: [
      {
        path: "examSystem",
        name: "examSystem",
        meta: {title: "考试系统"},
        component: () => import("@/views/MockExam/examSystem2024")
      },
      {
        path: "examRecord",
        name: "examRecord",
        meta: {title: "考试记录"},
        component: () => import("@/views/MockExam/examRecord2024")
      },
      {
        path: "examChapter",
        name: "examChapter",
        meta: {title: "按章练习"},
        component: () => import("@/views/MockExam/examChapter2024")
      },
      {
        path: "chapterRecord",
        name: "chapterRecord",
        meta: {title: "练习记录"},
        component: () => import("@/views/MockExam/chapterRecord2024")
      },
      {
        path: "mistakeRecord",
        name: "mistakeRecord",
        meta: {title: "错题记录"},
        component: () => import("@/views/MockExam/mistakeRecord2024")
      },
      {
        path: "collectRecord",
        name: "collectRecord",
        meta: {title: "收藏记录"},
        component: () => import("@/views/MockExam/collectRecord")
      }
    ]
  },
  {
    //考试说明步骤
    path: '/:flag/realMockExam',
    name: 'RealMockExam',
    component: () => import("@/views/RealMockExam"),
    redirect: '/:flag/realMockExam/step1',
    //20220628 综合调整样式和其它一致
    // redirect: to => {
    //     const {query} = to
    //     //console.log(to, isCompositeCourse(query.siteCourseID, query.courseID))
    //     if (isCompositeCourse(query.siteCourseID, query.courseID)) {
    //         return '/:flag/realMockExam/compStep1'
    //     } else {
    //         return '/:flag/realMockExam/step1'
    //     }
    // },
    children: [
      {
        path: 'step1',
        name: 'Step1',
        component: () => import('@/views/RealMockExam/step1')
      },
      {
        path: 'step2',
        name: 'Step2',
        component: () => import('@/views/RealMockExam/step2')
      },
      {
        path: 'step3',
        name: 'Step3',
        component: () => import('@/views/RealMockExam/step3')
      },
      {
        path: 'step4',
        name: 'Step4',
        component: () => import('@/views/RealMockExam/step4')
      }
      // {
      //     path: 'compStep1',
      //     name: 'CompStep1',
      //     component: () => import('@/views/RealMockExam/compStep1')
      // },
      // {
      //     path: 'compStep2',
      //     name: 'CompStep2',
      //     component: () => import('@/views/RealMockExam/compStep2')
      // },
      // {
      //     path: 'compStep3',
      //     name: 'CompStep3',
      //     component: () => import('@/views/RealMockExam/compStep3')
      // },
      // {
      //     path: 'compStep4',
      //     name: 'CompStep4',
      //     component: () => import('@/views/RealMockExam/compStep4')
      // }
    ]
  },
  {
    //开始考试
    path: '/:flag/doExam',
    name: 'DoExam',
    component: () => import('@/views/DoExam/index')
  },
  // {
  //     //综合 开始考试
  //     path: '/:flag/compDoExam',
  //     name: 'CompDoExam',
  //     component: () => import('@/views/DoExam/compIndex')
  // },
  {
    path: '/:flag/analysis',
    name: 'analysis',
    meta: {title: '答案解析'},
    component: () => import('@/views/Analysis/index')
  },
  {
    path: '/:flag/mistakeRedo',
    name: 'mistakeRedo',
    meta: {title: '错题记录重做'},
    component: () => import('@/views/Analysis/mistakeRedo')
  },
  {
    //普通卷
    path: '/ordinaryExam',
    name: 'OrdinaryExam',
    component: () => import('@/views/OrdinaryExam')
  },
  {
    //开始按章练习
    path: '/:flag/doExamChapter',
    name: 'doExamChapter',
    component: () => import('@/views/DoExamChapter')
  },
  // 模考活动
  {
    // 模考普通卷（一模二模）
    path: '/moKao/activityOrdinary',
    name: 'moKaoActivityOrdinary',
    component: () => import('@/views/Activity/Mokao/activityOrdinary')
  },
  {
    // 模考随机卷（自由模）
    path: '/moKao/activity',
    name: 'moKaoActivity',
    component: () => import('@/views/Activity/Mokao/activity')
  },
  {
    // 模考解析页面
    path: '/moKao/moKaoAnalysis',
    name: 'moKaoAnalysis',
    component: () => import('@/views/Activity/Mokao/moKaoAnalysis')
  }
]

const createRouter = () => new Router({
    base: "/",
    routes: fixedRoutes
})

const router = createRouter()

//设置路由导航守卫
router.beforeEach((to, from, next) => {
    // to要去的页面 from从哪里来 next放行
    const userID = getCookie('cdeluid') ? Number(getCookie('cdeluid')) : null
    if (userID) {
        next()
    } else {
        Message.warning('未登录或登录已失效')
        //弹窗登录
        window.CDEL.ucLogin()
    }
})

export default router
